import { gql } from '@apollo/client';

const listMlsesQuery = gql`
  query ListMlsesQuery($postalCode: String!) {
    webMarket {
      listMlses(input: { postalCode: $postalCode }) {
        mlses {
          mlses {
            identifier
            displayName
          }
        }
      }
    }
  }
`;

export default listMlsesQuery;
